// @ts-nocheck

export function getGlobalThis(): typeof globalThis {
  if (typeof globalThis !== 'undefined') {
    return globalThis;
  } else if (typeof self !== 'undefined') {
    return self;
  } else if (typeof window !== 'undefined') {
    return window;
  } else if (typeof global !== 'undefined') {
    return global;
  }
}

if (typeof globalThis === 'undefined') {
  globalThis = getGlobalThis();
}
